var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.832 4c.233 0 .43.08.591.24.16.161.241.359.241.592v9.504h9.504c.233 0 .43.08.591.24.16.162.241.359.241.592 0 .233-.08.43-.24.591a.804.804 0 0 1-.592.241H1.664c-.46 0-.853-.162-1.177-.487A1.604 1.604 0 0 1 0 14.336V4.832c0-.233.08-.43.24-.591C.402 4.08.6 4 .833 4zM14 0a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h9zm-1 2H6v9h2.144V7.721h4.287V6.05H8.144V3.671H13V2z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgField);
export default __webpack_public_path__ + "static/media/field.18301d5c3fd07b2d49e66740b1600060.svg";
export { ForwardRef as ReactComponent };